 
import CreateHttpService from "../../helpers/HttpService";

 
 


 // Registration
const userRegistration = async (value:any) => {  
   const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/auth/admin-register-user`,value)  
  return data
}
 // Registration
const getallReguser = async () => { 
  
    const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.get( `/api/v1/auth/users`)  
 
  return data
}
 // Get Login User
const getLoginUser = async () => { 
   
  const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.get( `/api/v1/auth/current-user`)  
 
  return data
}
 // Edit Users
const EditUsers = async (inputs:any) => { 
  const { input, id } = inputs; 
  const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post(`/api/v1/application/${id}`, input)   
  return data
}



const registrationSlice = { 
  userRegistration,
  getallReguser,
  getLoginUser,
  EditUsers
}

export default registrationSlice